import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-maroon text-sand">

      {/* Main grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 px-8 md:px-14 pt-16 pb-12">

        <div className="md:col-span-1">
          <div className="font-serif text-2xl font-light tracking-[0.08em] text-light mb-4">
            Roastery<br /><span className="text-sand/40">Coffee House</span>
          </div>
          <p className="text-sm text-sand/50 leading-relaxed max-w-xs mb-6">
            India's home for specialty coffee — in our cafés, and in yours.
          </p>
          <div className="flex flex-col gap-1.5">
            <a href="mailto:support@roasterycoffee.co.in" className="text-xs text-sand/45 hover:text-light transition-colors link-underline">
              support@roasterycoffee.co.in
            </a>
            <a href="tel:+919505263320" className="text-xs text-sand/45 hover:text-light transition-colors link-underline">
              +91 95051 63320
            </a>
          </div>
          <div className="flex gap-5 mt-6">
            {[
              { label: 'IG',  url: 'https://www.instagram.com/roasterycoffeehouseindia/' },
              { label: 'FB',  url: 'https://www.facebook.com/roasterycoffeehousehyd' },
              { label: 'YT',  url: 'https://www.youtube.com/@roasterycoffeehouseindia' },
            ].map(s => (
              <a key={s.label} href={s.url} target="_blank" rel="noreferrer"
                className="text-xs tracking-widest text-sand/35 hover:text-light transition-colors uppercase link-underline">
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {[
          {
            title: 'Coffee',
            links: [
              { label: 'Coffee Beans',      to: '/shop' },
              { label: 'Café Menu',         to: '/menu' },
              { label: 'Brew Guide',        to: '/shop' },
              { label: 'Ritual Membership', to: '/shop' },
            ]
          },
          {
            title: 'Visit Us',
            links: [
              { label: 'Hyderabad',      to: '/cafes' },
              { label: 'Kolkata',        to: '/cafes' },
              { label: 'Delhi & Noida',  to: '/cafes' },
              { label: 'Jaipur',         to: '/cafes' },
              { label: 'Lucknow',        to: '/cafes' },
            ]
          },
          {
            title: 'Company',
            links: [
              { label: 'About Us', to: '/about' },
              { label: 'Media',    href: 'https://roasterycoffee.co.in/media/' },
              { label: 'Contact',  href: 'mailto:support@roasterycoffee.co.in' },
              { label: 'Terms',    href: 'https://roasterycoffee.co.in/terms-conditions/' },
              { label: 'Privacy',  href: 'https://roasterycoffee.co.in/privacy-policy-2/' },
            ]
          },
        ].map(col => (
          <div key={col.title}>
            <div className="text-[10px] font-medium tracking-[0.2em] uppercase text-sand/40 mb-5">{col.title}</div>
            <ul className="flex flex-col gap-3">
              {col.links.map(l => (
                <li key={l.label}>
                  {l.to
                    ? <Link to={l.to} className="text-sm text-sand/50 hover:text-light transition-colors link-underline">{l.label}</Link>
                    : <a href={l.href} target={l.href?.startsWith('http') ? '_blank' : undefined} rel="noreferrer"
                        className="text-sm text-sand/50 hover:text-light transition-colors link-underline">{l.label}</a>
                  }
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-sand/10 px-8 md:px-14 py-5 flex flex-col md:flex-row justify-between gap-2">
        <p className="text-xs text-sand/25 tracking-wide">
          © 2025 Roastery Coffee House · A unit of NAI Coffee Pvt. Ltd.
        </p>
        <div className="flex gap-6">
          {[
            { label: 'Shipping', url: 'https://roasterycoffee.co.in/shipping-policy/' },
            { label: 'Returns',  url: 'https://roasterycoffee.co.in/return-policy/' },
          ].map(l => (
            <a key={l.label} href={l.url} target="_blank" rel="noreferrer"
              className="text-xs text-sand/25 hover:text-sand/60 transition-colors">{l.label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
